<script>
import Drawer from "@/components/drawer.vue";
import Swal from "sweetalert2";

// Custom Components
import PageHeader from "@/components/page-header";
import ResellerUserDetails from "@/components/superAdmin/user/resellerForm.vue";
import superService from "@/helpers/APIService/super.service";
import Middleware from "@/helpers/middlewares";
import errorHandler from "@/helpers/errorHandler";
import appConfig from "@/app.config";

export default {
  page: {
    title: "Reseller User list",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Drawer,
    ResellerUserDetails,
    PageHeader,
  },
  data() {
    return {
      title: "Reseller User list",
      resellerUserData: [],
      dataId: "",
      isShowUserForm: false,
      selectedUser: null,
      isLoading: false,
      isEdit: false,
      isPasswordShow: false,
    };
  },
  mounted() {
    this.getUsers();
  },
  methods: {
    // Method is used to get reseller list
    async getUsers() {
      this.isLoading = true;
      try {
        const response = await superService.getHotelResellerList();
        if (response) {
          this.resellerUserData = response;
          this.isLoading = false;
        }
      } catch (error) {
        errorHandler(error);
      }
    },
    // Method is used to update reseller user details
    updatUserDetail(user) {
      this.isEdit = true;
      this.selectedUser = user;
      this.isShowUserForm = !this.isShowUserForm;
    },
    // Method is used to handle reseller form
    UserForm() {
      this.isEdit = false;
      this.selectedUser = null;
      this.isShowUserForm = !this.isShowUserForm;
    },
    // Method is used to handle reseller user submit
    handleUserSubmit() {
      this.UserForm();
      this.getUsers();
    },
    // Method is used to delete reseller user
    deleteResellerUser(id, index) {
      Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#238dfa",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: "Yes, delete it!",
      }).then(async (result) => {
        if (result.value) {
          superService
            .deleteHotelReseller(id)
            .then((response) => {
              if (response.status == false) {
                return Middleware.notification(response.message, "warning");
              }
              Middleware.notification(
                "User deleted successfully !!",
                "success"
              );
              this.resellerUserData.splice(index, 1);
            })
            .catch((error) => {
              errorHandler(error);
            });
        }
      });
    },
    // Method is used handle status change
    updateUserStatus(id, data) {
      superService
        .editHotelReseller(id, data)
        .then((response) => {
          Middleware.notification("Status change successfully !!", "success");
        })
        .catch((error) => {
          errorHandler(error);
        });
    },
  },
};
</script>
<template>
  <div>
    <PageHeader
      :title="title"
      :action="UserForm"
      text="Add New User"
      :isButton="true"
    />
    <b-card>
      <div class="table-responsive">
        <table class="table mb-0">
          <thead class="table-light">
            <tr>
              <th>E-mail</th>
              <th>First Name</th>
              <th>last Name</th>
              <th>Mobile No</th>
              <th>User Hotel</th>
              <th>Active</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody v-if="isLoading">
            <tr v-for="item in 10" :key="item">
              <td class="placeholder-glow" v-for="no in 7" :key="no">
                <span class="placeholder w-100 placeholder-lg"></span>
              </td>
            </tr>
          </tbody>
          <tbody v-else>
            <tr v-for="(user, index) in resellerUserData" :key="user.id">
              <td @click="updatUserDetail(user)">
                {{ user.email ? user.email : "-" }}
              </td>
              <td @click="updatUserDetail(user)">
                {{ user.first_name ? user.first_name : "--" }}
              </td>
              <td @click="updatUserDetail(user)">
                {{ user.last_name ? user.last_name : "--" }}
              </td>
              <td @click="updatUserDetail(user)">
                {{ user.mobile ? user.mobile : "--" }}
              </td>

              <td @click="updatUserDetail(user)">
                {{ user.user_hotel.name ? user.user_hotel.name : "--" }}
              </td>
              <td>
                <div class="form-check form-switch">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    v-model="user.is_active"
                    @change="
                      updateUserStatus(user.id, {
                        is_active: user.is_active,
                      })
                    "
                  />
                </div>
              </td>
              <td>
                <div class="d-flex align-items-center">
                  <i
                    v-b-popover.hover="'Edit'"
                    class="fas fa-pencil-alt text-success"
                    @click="updatUserDetail(user)"
                  ></i>
                  <i
                    v-b-popover.hover="'Delete'"
                    class="mdi mdi-trash-can text-danger fs-5 ms-2"
                    @click="deleteResellerUser(user.id, index)"
                  ></i>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </b-card>
    <!-- Drawer is used to handle reseller form -->
    <Drawer
      @close="UserForm"
      :closeable="true"
      :maskClosable="true"
      :zIndex="1002"
    >
      <div v-if="isShowUserForm">
        <ResellerUserDetails
          :userDetails="this.selectedUser"
          :isEdit="this.isEdit"
          @cancelSubmit="UserForm"
          @submitted="handleUserSubmit"
        />
      </div>
    </Drawer>
  </div>
</template>

<style scoped>
.w-250 {
  width: 250px;
}
</style>
